<div class="how-it-works-wrapper">
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
          <div class="title">
            How it works
          </div>
      </div>
      <span class="hr-yellow mt-3"></span>
    </div>
  </div>
  <div class="container-fluid carousel-container">
    <ngx-glide [showArrows]="false" [showBullets]="true" [perView]="isMobile? 1:1.2" [bound]="true" [gap]="20" [dragThreshold]="false" [breakpoints]="breakpoints">
      <div class="slide-card" [ngClass]="'card-'+(i+1)" *ngFor="let item of howItWorksInfo; index as i">
        <div class="container-fluid">
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 p-0 d-flex flex-column justify-content-center" [ngClass]="isMobile?'order-last':''">
              <div class="wrapper">
                <div class="title">
                  Step {{i + 1}}
                </div>
                <div class="sub-title">
                  {{ item.subTitle}}
                </div>
                <div class="description">
                  {{ isMobile? (item.desc.mob !==null?item.desc.mob: item.desc.desk):item.desc.desk }}
                </div>
                <div class="action mt-5" *ngIf="!isMobile">
                  <button *ngIf="!showPaymentBtn" class="primary active" mat-button (click)="utilService.scrollIntoViewSmoothly('form-donate')">
                    {{item.buttonLabel}}
                  </button>
                  <button *ngIf="showPaymentBtn" class="primary active" mat-button [hidden]="isMobile" [routerLink]="[]" [queryParams]="{pr: 'c'}" queryParamsHandling="merge" (click)="onPaymentClick()">
                    <span *ngIf="!vars.isOrderLoading">{{item.buttonLabel}}</span>
                    <span *ngIf="vars.isOrderLoading" class="lds-ellipsis"><div></div><div></div><div></div><div></div></span>
                    </button>
                </div>
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-12 col-sm 12 col-xs-12 p-0" [ngClass]="isMobile?'order-first':''">
              <div class="img-wrapper">
                <div class="how-it-works-bg-image"></div>
                <div class="img-group" *ngIf="i==0" [ngClass]="i==0 ? 'grid':''">
                  <div class="img-card" *ngFor="let img of item.images; index as j">
                    <img data-src="{{ '/assets/images/sip/' + 'img-'+(j+1) + '.png' }}" alt="no image">
                    <div class="text">
                      {{ img.text }}
                    </div>
                  </div>
                </div>
                <div class="img-group" *ngIf="i!==0" [ngClass]="i!==0?'single':''">
                  <img data-src="{{ '/assets/images/sip/' + item.images[0].url }}" alt="no image" >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ngx-glide>
  </div>
</div>
